import { useState, useRef } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';

const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

// This homepage is currently used for fasttrackiron.com and rvwholesalenetwork.com
const SplashSiteHomePage = (props) => {

	const [showFeedbackModal, setShowFeedbackModal] = useState(false);
	const ref = useRef(null);
	const toggleFeedbackModal = () => {
		setShowFeedbackModal(showFeedbackModal => !showFeedbackModal);
		if (showFeedbackModal && ref?.current) {
			setTimeout(() => {
				ref.current.focus();
			}, 150);
		}
	}
	const handleKeyPress = (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleFeedbackModal();
		}
	}

    return (
		<>
			{showFeedbackModal &&
				<FeedbackModal
				{...props?.ContactUsModel} toggleModal={toggleFeedbackModal} title={translator.translate('sandhills.requestwholesaleaccess')}
				/>}

			<div className="header">
				<div className="wrap">
					<div className="logo">
						<div>
							<img src={props.LogoURL} alt={props.LogoAltText}></img>
						</div>
					</div>
					<div className="navigation">
						<ul>
							{props?.NavigationLinks?.map((link, index) => {
								return (
								<li key={index}><a href={link.URL} target="_blank">{link.Text}</a></li>)
							})}
						</ul>
					</div>
					<div className="cta">
						<div className="btn feedback-btn" tabIndex={0} role="button" onClick={toggleFeedbackModal} onKeyDown={handleKeyPress}>{translator.translate("sandhills.tradepubwebsite.mvc.getstarted")}</div>
					</div>
				</div>
			</div>

			<div className="hero">
				<div className="wrap">
					<div className="flex-row">
						<div className="flex-col">
							<h1>{props.SiteInfoHeader}</h1>
							<p>{props.SiteInfoDescription}</p>
							<div className="btn feedback-btn" ref={ref} tabIndex={0} role="button" onClick={toggleFeedbackModal} onKeyDown={handleKeyPress}>{props.SiteInfoButtonText}</div>
						</div>
						<div className="flex-col">
							<img src={props.SiteInfoImageURL} alt={props.SiteInfoImageAltText}></img>
						</div>
					</div>
				</div>
			</div>
			<div className="main icon-container">
				<div className="wrap">
					<h2>{props.IconContainerTitle}</h2>
					<div className="flex-row">
						{props.IconContainers.map((item, index) => {
							return (
							<div key={index} className="flex-col icon">
								<i className={item.IconClassName}></i>
								<h3>{item.Title}</h3>
								<p>{item.Description}</p>
							</div>)
						})}
					</div>
				</div>
			</div>
			<div className="main ts-container">
				<div className="wrap">
					<div className="flex-row">
						{props.SiteContacts && props.SiteContacts.length > 0 &&
							(props.SiteContacts.map((contact, index) => {
								return (
								<div key={index} className="flex-col ts-contact">
									<a href={contact.SearchURL} target="_blank">
										<img src={contact.SiteLogoURL} alt={contact.SiteLogoAltText}></img>
									</a>
									<div>
										<a href={contact.SearchURL} target="_blank"><h4>{contact.Title}</h4></a>
										<a href={"tel:" + contact.PhoneNumber}>{contact.PhoneNumber}</a>
										<br />
										<a href={"tel:" + contact.AltPhoneNumber}>{contact.AltPhoneNumber}</a>
										<br />
										{translator.translate("sandhills.fax")}: {contact.Fax}
									</div>
									<span className="underline-link feedback-btn" onClick={toggleFeedbackModal} onKeyDown={handleKeyPress}>{translator.translate("sandhills.sendemail")}</span>
								</div>)
							}))
						}
					</div>
				</div>
			</div>
    </>
);
}

export default SplashSiteHomePage;
